import Tooltip from "components/Tooltip";
import {FC, ReactNode} from "react";
import {Info} from "lucide-react";

export interface StatusChip {
  label: string;
  sublabel: string;
  tooltip: string;
  color: string;
  icon: ReactNode;
}

interface Props {
  chips: StatusChip[];
}

const StatusBar: FC<Props> = ({chips}) => (
  <div className="rounded-2xl overflow-hidden mb-5 border border-brand-border bg-white">
    <div className="flex h-1.5">
      {chips.map((chip, i) => (
        <div key={i} className="flex-1" style={{backgroundColor: chip.color}} />
      ))}
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 divide-x divide-brand-border">
      {chips.map((chip, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-4">
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 text-white"
            style={{backgroundColor: chip.color}}
          >
            {chip.icon}
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1">
              <span className="font-bold text-sm text-brand-navy">{chip.label}</span>
              <Tooltip position="right" text={chip.tooltip} className="bg-slate-800">
                <Info className="w-3.5 h-3.5 text-brand-muted flex-shrink-0 cursor-default" />
              </Tooltip>
            </div>
            <p className="text-xs text-brand-muted">{chip.sublabel}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default StatusBar;
